import React, { useContext, useEffect, useRef, useState } from 'react';
import { Logo } from '../../assets/icons/IconComponents';
import { Link, useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie'
import Modal from '../modal/Modal'
import { Store } from '../utils/Store';
import createAxiosInstance, { setAuthToken } from '../axios/axiosCustom'
import { getRefreshToken } from '../utils/getRefreshToken';
import { useTranslation } from 'react-i18next';
import Login from '../login/Login';



function TopNav() {
  const [active, setActive] = useState("#About")
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [userLoggedIn, setUserLoggedIn] = useState(false)
  const [isDektop, setIsDektop] = useState(false)

  const { state, dispatch} = useContext(Store)
  const buttonRef = useRef(null)
  const navigate = useNavigate()
  const { t } = useTranslation()

  const sections = [
    { top: 0, href: "about_us" },
    { top: 600, href: "categories" },
    { top: 1100, href: "contact" }
  ]

  function isMobileScreen() {
    return window.innerWidth <= 768
  }

  const scrollTo = (section) => {
    // if page is changed get from localstorage some key to handle scroll
    setActive(section.href)
    window.scrollTo({ top: section.top, behavior: "smooth" })
  }

  const onLoginClick = async (e) => {
    if(userLoggedIn) {
      await onLoggout()
      return
    }

    setIsModalOpen(true)
  }

  const onLoggout = async () => {
    let refreshToken = Cookies.get('refreshToken')

    const axiosCustom = await createAxiosInstance()
    let resp = await axiosCustom.post('/logout', {refreshToken: refreshToken});
    if(!resp) {
      return
    }

    dispatch({ type: 'USER_LOGOUT' })
    Cookies.remove('refreshToken')
    sessionStorage.removeItem('token')
    setLoginText()
    navigate("/") 
    window.location.reload()
  }

  const setLoginText = (code) => {
    buttonRef.current.textContent = (userLoggedIn || code) ? t('logout') : t('login')
  }

  const handleScroll = () => {
    const currentPath = window.location.pathname
    if(currentPath == '/myEvents') {
      setActive('my_events')
      return
    }

    const scrollPosition = window.scrollY
    
    const currentSection = sections.reduce((prev, curr) => {
      return scrollPosition >= curr.top ? curr : prev
    }, sections[0])

    setActive(currentSection.href)
  }

  const handleNav = () => {
    const currentPath = window.location.pathname
    if(currentPath == '/myEvents') {
      setActive('my_events')
    }
  }
  
  const toggleLoading = (code) => {
    let submitBt = document.querySelector('.login-btn')
    let spinner = document.querySelector('.spinner')

    if(code) {
      submitBt.classList.add('bt-loading')
      submitBt.setAttribute('disabled', true)
      spinner.removeAttribute('hidden')
    } else {
      submitBt.classList.remove('bt-loading')
      submitBt.removeAttribute('disabled')
      spinner.setAttribute('hidden', true)
    }
  }

  const onLoginCallback = (e) => {
    if(e.closeModal) {
      setIsModalOpen(false)
      return
    }

    if(e.succ) {
      setIsModalOpen(false)
      setUserLoggedIn(true)
      setLoginText(true)
      navigate("/myEvents")
    }
  }
  
  useEffect(() => {
    let isOnMobile = isMobileScreen()
    setIsDektop(!isOnMobile)

    setUserLoggedIn(state?.userInfo ? true : false)
    async function getToken() {
      let tokenResp = await getRefreshToken(true)
      setLoginText(tokenResp?.setLoginText)
      setUserLoggedIn(tokenResp?.setUserLoggedIn)
    }getToken()
    handleNav()

    document.addEventListener("scroll", handleScroll)
    return () => document.removeEventListener("scroll", handleScroll)

  }, [])

  return (
    <>
    <div className="top-nav">
      <div className="top-nav-logo">
        <Logo />
        <b>feentapp</b>
      </div>
      <div className="right-top-nav">
      {sections.map((section) => (
        <Link
          key={section.href}
          href={section.href}
          className={active === section.href ? "selected" : ""}
          to="/"
          onClick={() => scrollTo(section)}
          >
          {t(section.href)}
        </Link>
      ))}

      {userLoggedIn && <Link className={active === 'my_events' ? "selected" : ""} onClick={() => setActive('my_events')} to="/myEvents">{t('my_events')}</Link>}
      </div>
      {isDektop && <button ref={buttonRef} className="bt login-bt" onClick={(e) => onLoginClick(e)}>{t('login')}</button>}
    </div>
    <Modal isOpen={isModalOpen} className="login-modal lg">
      <Login callback={onLoginCallback} />
    </Modal>
    </>
  );
}

export default TopNav
